import { generateSkinDefaults } from '@wix/editor-elements-panel';

import type { SiteAssetsSkinParams } from '../TextEffectsShared/TextEffectsShared.skinParams';
import { textEffectsSharedSkin } from '../TextEffectsShared/TextEffectsShared.skinParams';

export const TextEffectsNoisySkin = {
  ...textEffectsSharedSkin,
  'text-effects-color-1': {
    type: 'COLOR',
    defaultValue: '#000000',
  },
  'squiggly-level': {
    type: 'CSSString',
    defaultValue: '',
  },
} as const satisfies SiteAssetsSkinParams;

const TextEffectsNoisySkinDefinitionMap: Record<string, SiteAssetsSkinParams> =
  {
    'wixui.skins.TextEffectsNoisy': TextEffectsNoisySkin,
  };

export default generateSkinDefaults(TextEffectsNoisySkinDefinitionMap);
